<template>
    <div class="flex-grow-0">
        <template v-if="!isEditing">
            <slot
                name="not-edit-buttons"
            ></slot>
        </template>
        <div v-if="isEditing">
            <v-btn
                text
                color="primary"
                @click="$emit('cancel')"
            >
                {{ $t("Cancel") }}
            </v-btn>
            <v-btn
                color="primary"
                class="white--text"
                @click="$emit('save')"
            >
                {{ $t("Save") }}
            </v-btn>
        </div>
        <template v-if="!isEditing">
            <slot name="right-buttons"></slot>
        </template>
    </div>
</template>

<script>
import SalesInvoiceModule from "@/store/modules/sales_invoice";
export default {
    name: "InvoiceActionsToolbar",
    props: {
        showStatus:{
            type: Boolean,
            default: false
        },
        invoiceStatus: {
            type: String,
            default: ''
        },
        invoiceProcessStatus: {
            type: String,
            default: ''
        },
        isEditing: {
            type: Boolean,
            default: false
        },
    },
    setup() {
        const {
            getStatusColorMap,
        } = SalesInvoiceModule();
        return {
            getStatusColorMap
        };
    }
};
</script>
